var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-entity',{attrs:{"geometry":"width: 1; height: 1; depth: 2;","material":"visible: false"}},[_c('a-cylinder',{attrs:{"color":_vm.color,"height":0.1,"radius":0.25,"rotation":"90 0 0","position":"0 0 -0.95"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }